// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__163Zf","list":"styles_list__2j-Cp"};